<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img
          src="https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg"
          height="300px"
        >
          <v-layout
            column
            fill-height
          >
            <v-card-title>
              <v-btn dark icon>
                <v-icon>chevron_left</v-icon>
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn dark icon class="mr-3">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </v-card-title>

            <v-spacer></v-spacer>

            <v-card-title class="white--text pl-5 pt-5">
              <div class="display-1 pl-5 pt-5"></div>
            </v-card-title>
          </v-layout>
        </v-img>

        <v-list two-line>
          <!-- <v-list-tile @click="">
            <v-list-tile-action>
              <v-icon color="indigo">phone</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>(41) 3022-1459</v-list-tile-title>
              <v-list-tile-sub-title>Mobile</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>chat</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="">
            <v-list-tile-action></v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>(41) 3022-1459</v-list-tile-title>
              <v-list-tile-sub-title>Work</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>chat</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>
 -->
          <v-list-tile @click="">
            <v-list-tile-action>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{profile.email}}</v-list-tile-title>
              <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- <v-divider inset></v-divider>

          <v-list-tile @click="">
            <v-list-tile-action>
              <v-icon color="indigo">location_on</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Rua brasilino moura, 63</v-list-tile-title>
              <v-list-tile-sub-title>Curitiba - Paraná</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile> -->

        </v-list>
        
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('auth', ['getUser'])
    },
    components: {},
    data: () => ({
      profile: {}
    }),
    methods: {
      loadingProfile () {
        const config = {
          params: {
            crm: this.auth.auth.myClinic.crm,
            customer: this.customer
          }
        }
        axios.get(`${process.env.URL}/my-clinic-new/schedule-sync/doctors/profile`, config).then((result) => {
          this.profile = result.data.result
        })
      }
    },
    mounted () {
      this.loadingProfile()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/profile/index.vue